<template>
    <div class="nav-wrapper" :class="{ 'nav-hover': isHovered }" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
      <!-- Desktop Side Nav -->
      <div class="desktop-nav">
        <router-link 
          v-for="item in navItems" 
          :key="item.path" 
          :to="item.path"
          class="nav-item"
          :aria-label="item.label"
          @click="isHovered = false"
        >
          <Icon :icon="item.icon" class="nav-icon" />
          <span class="nav-label">{{ item.label }}</span>
          <div class="nav-tooltip">{{ item.label }}</div>
        </router-link>
      </div>
  
      <!-- Mobile Bottom Nav -->
      <div class="mobile-nav">
        <router-link 
          v-for="item in navItems" 
          :key="item.path" 
          :to="item.path"
          class="mobile-nav-item"
          :aria-label="item.label"
        >
          <Icon :icon="item.icon" class="mobile-nav-icon" />
          <span class="mobile-nav-label">{{ item.label }}</span>
        </router-link>
      </div>
    </div>
  </template>
  
  <script setup>
  import { Icon } from "@iconify/vue";
  import { ref } from 'vue';
  
  const isHovered = ref(false);
  
  const navItems = [
    { path: '/', icon: 'teenyicons:home-outline', label: 'Home' },
    { path: '/blog/1', icon: 'material-symbols:article', label: 'Blog' },
    { path: '/gallery', icon: 'mage:image-fill', label: 'Gallery' },
    { path: '/resources', icon: 'ph:package-light', label: 'Resources' },
    { path: '/about', icon: 'mdi:about', label: 'About' }
  ];
  </script>
  
  <style scoped>
  /* Main Wrapper */
  .nav-wrapper {
    @apply fixed z-30 h-full top-0;
  }
  
  /* Desktop Navigation - Hidden by default, appears on hover */
  .desktop-nav {
    @apply hidden sm:flex flex-col items-start justify-center h-full w-16 bg-gray-900/80 backdrop-blur-md border-r border-gray-700/50;
    @apply transition-all duration-300 ease-in-out overflow-hidden;
    transform: translateX(-20%);
  }
  
  .nav-hover .desktop-nav {
    @apply w-48 pl-4;
    transform: translateX(0);
    box-shadow: 8px 0 15px -5px rgba(0, 0, 0, 0.3);
  }

  .nav-hover   .nav-item {
    transform: translateX(-5%);
  }
  
  .nav-item {
    @apply flex items-center w-full py-4 text-gray-300 hover:text-white relative;
    @apply transition-all duration-200;
    transform: translateX(37.5%);
  }
  
  .nav-item:hover {
    @apply bg-gray-700/30;
    padding-left: 20px;
  }
  
  .nav-item.router-link-active {
    @apply text-cyan-400;
  }
  
  .nav-icon {
    @apply w-6 h-6 min-w-[24px] transition-transform duration-200;
  }
  
  .nav-item:hover .nav-icon {
    @apply scale-110;
  }
  
  .nav-label {
    @apply ml-4 whitespace-nowrap opacity-0;
    @apply transition-opacity;
    transition-duration: 1200ms;
  }
  
  .nav-hover .nav-label {
    @apply opacity-100;
    
  }
  
  .nav-tooltip {
    @apply absolute left-full ml-4 px-3 py-2 bg-gray-800 text-white text-sm rounded-md shadow-lg;
    @apply opacity-0 pointer-events-none transition-opacity duration-200;
    white-space: nowrap;
  }
  
  .nav-item:hover .nav-tooltip {
    @apply opacity-100;
  }
  
  .nav-hover .nav-item:hover .nav-tooltip {
    @apply opacity-0;
  }
  
  /* Active indicator */
  .nav-item.router-link-active::before {
    content: '';
    @apply absolute -left-1 h-6 w-1 bg-cyan-400 rounded-r-full;
  }
  
  /* Mobile Navigation */
  .mobile-nav {
  @apply sm:hidden flex flex-row items-center justify-around fixed bottom-0 w-full;
  @apply bg-gray-900/90 backdrop-blur-md border-t border-gray-700/50 h-16;
  
}
  
  .mobile-nav-item {
    @apply flex flex-col items-center justify-center h-full px-2 text-gray-300 hover:text-white;
    @apply transition-all duration-200 relative flex-1;
  }
  
  .mobile-nav-item.router-link-active {
    @apply text-cyan-400;
  }
  
  .mobile-nav-icon {
    @apply w-6 h-6 transition-transform duration-200;
  }
  
  .mobile-nav-item:hover .mobile-nav-icon {
    @apply scale-110;
  }
  
  .mobile-nav-label {
    @apply text-xs mt-1;
  }
  
  /* Animation for active item */
  .mobile-nav-item.router-link-active::after {
    content: '';
    @apply absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-cyan-400 rounded-full;
    @apply animate-pulse duration-1000;
  }
  </style>